import React from 'react';
import { MarkdownPageData } from '@modules/utilities/pageBuild/content';
import Landing from './Landing';

export type LandingPageData = MarkdownPageData;

// the landing page can also be the template for assigned pages
export const isUsingLandingPage = (data: LandingPageData | object) => {
  return 'template' in data && data.template === 'landing-page';
};

const LandingPage = ({ data }: { data: LandingPageData }) => {
  const { title, meta, content } = data;
  return (
    <Landing
      banner={meta.banner}
      content={content}
      title={title}
      openGraphMeta={{
        title: title || meta.banner?.title,
        description: meta.banner?.subtitle ?? '',
        imageUrl: meta.banner?.backgroundUrl,
      }}
    />
  );
};

export default LandingPage;
